/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespComplementaryItemsGrid_viewer$ref = any;
type PdpRespSimilarItemsGrid_similarItems$ref = any;
type PdpRespSimilarItemsGrid_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsFooter_viewer$ref: FragmentReference;
export type PdpRespSimilarItemsFooter_viewer = {|
  +visuallySimilarGridItems?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string,
        +$fragmentRefs: PdpRespSimilarItemsGrid_similarItems$ref,
      |}
    |}>
  |},
  +$fragmentRefs: PdpRespSimilarItemsGrid_viewer$ref & PdpRespComplementaryItemsGrid_viewer$ref,
  +$refType: PdpRespSimilarItemsFooter_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isArt",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isArt",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "visuallySimilarGridItems",
          "name": "visualSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 6,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "itemPk",
              "variableName": "itemId",
              "type": "String!"
            }
          ],
          "concreteType": "VisualSearchConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "VisualSearchEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItemsGrid_similarItems",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '676208e9a8b714e6e268e3996f020555';
module.exports = node;
